import { render, staticRenderFns } from "./SalaryApproved.vue?vue&type=template&id=61c2e3ee&scoped=true"
import script from "./SalaryApproved.vue?vue&type=script&lang=js"
export * from "./SalaryApproved.vue?vue&type=script&lang=js"
import style0 from "./SalaryApproved.vue?vue&type=style&index=0&id=61c2e3ee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c2e3ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61c2e3ee')) {
      api.createRecord('61c2e3ee', component.options)
    } else {
      api.reload('61c2e3ee', component.options)
    }
    module.hot.accept("./SalaryApproved.vue?vue&type=template&id=61c2e3ee&scoped=true", function () {
      api.rerender('61c2e3ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/employeeSalary/SalaryApproved.vue"
export default component.exports